<template>
  <div class="main_center" ref="middle">
<!--    <img src="@/assets/img/track3.png" alt="">-->
    <div class="track-content">
      <div class="track-top">
<!--        <el-cascader-->
<!--          popper-class="moveCascader"-->
<!--          style="width:25%"-->
<!--          :options="options"-->
<!--          clearable-->
<!--          placeholder="请选择场地楼层"-->
<!--          v-model="filedItem"-->
<!--          @change="selectChange"-->
<!--        />-->
        <el-select :popper-append-to-body="false"
                   @change="selectChange"
                   placeholder="请选择"
                   v-model="filedItem"
                   value-key="value">
          <el-option-group
                  :key="group.label"
                  :label="group.label"
                  v-for="group in options">
            <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item"
                    v-for="item in group.children">
            </el-option>
          </el-option-group>
        </el-select>
        <div class="top-date">
          {{ nowtime | updatetime }}
          <el-button type="text" class="el-icon-rank full" @click="screen"></el-button>
        </div>
      </div>
      <div class="track-middle">
        <el-row :gutter="6" v-if="videoList.length > 0">
          <el-carousel :autoplay="false"
                       v-if="videoList.length > 0"
                       style="height:900px;"
                       indicator-position="none">
            <el-carousel-item v-for="i in Math.ceil(videoList.length / 6)" :key="i"  style="height:900px">
              <el-col :span="total<=1?24:total<=4?12:8"
                      style="margin-bottom: 6px"
                      v-for="(item,index) in videoList.slice((i-1)*6,videoList.length>=(i)*6?(i*6):(videoList.length))"
                      :key="item.id">
                <guardVideo :videoInfo="item" :i="index" :total="total" :record="true" :height="total<=2?'900px':'450px'"></guardVideo>
              </el-col>
            </el-carousel-item>
          </el-carousel>
        </el-row>
        <el-row v-else style="position: relative;height:900px">
          <iframe
                  v-if="isIE"
                  style="position:absolute;z-index:-1;width:100%;height:100%;top:0;left:0;right:0;bottom:0"
                  allowtransparency="true"
                  frameborder="0"
          />
          <stream-player
                  ref="streamPlayerRefs1"
                  :width="'850px'"
                  :height="vlcHeight"
                  :video-url.sync="videoUrl"
                  video-code="flv"
          />
        </el-row>

      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
import { isIEBrowser } from '@/utils'
import guardVideo from './components/guardVideo';
import StreamPlayer from '@/components/videoPlayer/streamPlayer'
export default {
  components: {
    guardVideo,
    StreamPlayer
  },
  data() {
    return {
      options: [],
      filedItem: {},
      videoList:[],
      location:'',
      tradeOrgId:'',
      nowtime:'',
      timer:null,
      vlcWidth: '',
      vlcHeight: '',
      isIE: false,
      // 视频流
      videoUrl: '',
      test:[1,2,3,4],
      currentOffset:0,
      width:"",
      fatherWith:0,
      box:'',
      total:0,
      pageIndex:1,
      pageSize:6,
      // 中间整体全屏
      fullscreen: false,
      // 单个视频全屏
      videoFull:false
    };
  },
  filters: {
    updatetime: function(value) {
      return moment(value).format('YYYY年MM月DD日 HH:mm:ss');
    }
  },
  created() {
    this.getServerTime();
    this.isIE = isIEBrowser();
    this.getSelectData();
  },
  activated() {

  },
  mounted() {
    let _this = this;
    this.timer = setInterval(() => {
        if(_this.nowtime){
            _this.nowtime = new Date(_this.nowtime).getTime() + 1000;
        }else{
            _this.nowtime = new Date($.ajax({async: false}).getResponseHeader("Date"));
        }
    }, 1000);
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  beforeRouteLeave(from, to, next) {
    this.$destroy()
    next()
  },
  methods: {
    selectChange(val){
      this.tradeOrgId = val.tradeOrgId;
      this.location = val.value;
       this.getVideoData()
    },
      getServerTime(){
          this.$httpReq.get('/open/time').then((res)=>{
              this.nowtime = res.data.data || '';
          })
      },
    getSelectData(){
      this.$httpReq.get('/sysGuardConfig/getDropDownList').then((res)=>{
        if(res.data.code == '1'){
          let resData = res.data.data;
          this.options = resData;
          if(resData[0] && resData[0].children && resData[0].children[0]){
            this.tradeOrgId = resData[0].children[0].tradeOrgId;
            this.location = resData[0].children[0].value;
            this.filedItem = resData[0].children[0];
            this.getVideoData()
          }

        }
      })
    },
    getVideoData(){
      this.videoList = []
      this.$httpReq.get(`/sysGuardConfig/getGuardConfigs?tradeOrgId=${this.tradeOrgId}&location=${this.location}`).then((res)=>{
        if(res.data.code == '1'){
           this.videoList = res.data.data || [];
           this.total = this.videoList.length;
        }
      })
    },

    right() {
      if(this.currentOffset <= (-(this.fatherWith-4) / 10)*(20-10)) return
      this.currentOffset-=((this.fatherWith-4) / 10)
    },
    left() {
      if(this.currentOffset >= -2) return
      this.currentOffset+=((this.fatherWith-4) / 10)
    },
    // 下一页
    nextPage(){},
    // 全屏
    screen(){
      let element = this.$refs.middle;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
        document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
        element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
        // IE11
        element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
  },
};
</script>
<style lang="scss" scoped>
.track-content{
  width:100%;
  height: 100%;
  background: #001F39;
  border-radius: 2px;
  padding:0 16px 16px;
  color: #fff;
  .track-top{
    height:56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-select{
      /deep/ .el-input__inner{
        background: rgba(24, 144, 255, 0.25);
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 0.45);
        color: #fff;
      }
    }
    /deep/ .el-popper{
      border:none;
      background-color: #063b6b;
      color: #FFFFFF;
      .el-select-dropdown__item{
        background-color: #063b6b;
        color: #FFFFFF;
        &:hover{
          /*background: #efff01;*/
          background-color: #3196fa;
          color: #FFFFFF;
        }
      }
    }
    /deep/ .el-scrollbar__wrap{
      overflow-x: hidden;
      margin-bottom: 0px !important;
    }
    .top-date{
      .full{
        transform: rotate(45deg);
        opacity: 0.65;
        color:#fff;
        font-size: 24px;
        vertical-align: middle;
        margin-left:20px;
      }
    }
  }
  .track-middle{
    position: relative;
    height:900px;
    .track-video{
      width:100%;
      height:452px;
      // padding: 24px;
      background: #001F39;
      border-radius: 2px;
      display: inline-block;
      box-sizing: border-box;
      position: relative;
      .video-title-fixed{
        position:absolute;
        width:100%;
        height: 48px;
        z-index: 99;
        background: rgba(0, 13, 23, 0.6);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 22px;
        .video-left{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .left-title{
            font-size: 16px;
          }
          .sub{
            color: rgba(255, 255, 255, 0.25);
            padding:0 24px;
          }
          .left-adr{
            font-size: 12px;
          }
        }
        .video-right{
            transform: rotate(45deg);
          .el-button--text {
            opacity: 0.65;
            color:#fff;
            font-size: 24px;
            vertical-align: middle;
          }
        }
      }
      .video-img-fixed{
        height: 40px;
        width: calc(100% - 24px);
        position: absolute;
        bottom: 0px;
        margin:0 12px 9px 12px;
        overflow: hidden;
        .swiper-box{
          height:40px;
          vertical-align: middle;
          width:calc(100% - 32px);
          margin-left:16px;
          margin-right:16px;
          display: flex;
        }
        .icon-left{
          position: relative;
          width: 12px;
          height: 40px;
          background: rgba(255, 255, 255, 0.25);
          display: inline-block;
          top:-40px;
          left:0;
          cursor: pointer;
          .left{
            position: absolute;
            top:13px;
            left:0
          }
        }
        .icon-right{
          position: absolute;
          width: 12px;
          height: 40px;
          background: rgba(255, 255, 255, 0.25);
          display: inline-block;
          top:0;
          right:0;
          cursor: pointer;
          .right{
            position: absolute;
            right: 0;
            top: 13px;
          }
        }
      }
      .video-img-noicon{
        margin:0 12px 9px 8px;
        width:calc(100% - 20px);
        .swiper-box-noicon{
          width:100%;
          margin:0;
        }
      }
    }
    .icon-fixed{
      position: absolute;
      right: 0;
      font-size: 48px;
      z-index: 999;
      top: 47%;
      background: rgba(255, 255, 255, 0.25);
    }
  }
}

</style>
